import { render } from "./ShippingDelivery.vue?vue&type=template&id=491c8463"
import script from "./ShippingDelivery.vue?vue&type=script&lang=js"
export * from "./ShippingDelivery.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\bdroyelculture-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__